import React, { useCallback } from 'react';
import { Container, Card, CardBody, Button, Spinner } from 'reactstrap';
import CcrList from './components/ccr-list';
import { Link, useHistory } from 'react-router-dom';
import useGet from '../../helpers/hooks/useGet';
import usePatch from '../../helpers/hooks/usePatch';
const Ccr = (props) => {
  const history = useHistory();
  const [ccrs, , ccrsLoading, loadCcrs] = useGet('/ccrs', true);
  const handleEditCcr = useCallback(
    (obj) => {
      history.push(`/users/edit-ccr/${obj.id}`);
    },
    [history]
  );

  const [postCcr, postedData, postingError, dataPosting] = usePatch();
  const handleisActiveCcr = (ccr, isActive) => {
    postCcr({ isActive }, `/ccrs/${ccr.id}`).then((e) =>
      loadCcrs()
    );
  };


  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <div className='align-items-end d-flex justify-content-between mb-3'>
            <h4>CCR</h4>
            <Link to='/users/add-new-ccr'>
              <Button
                color='primary'
                outline
                type='button'
                size='sm'
                className='waves-effect waves-light'
              >
                Add New Ccr
                <i className='mdi mdi-plus align-middle ml-2'></i>
              </Button>
            </Link>
          </div>
          <Card>
            <CardBody>
              {ccrsLoading ? (
                <div className='text-center'>
                  <Spinner className='mr-2' color='primary' />
                </div>
              ) : (
                <CcrList
                  ccrs={ccrs}
                  editCcr={handleEditCcr}
                  onStatusChange={handleisActiveCcr}
                ></CcrList>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default Ccr;
